import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useProfile } from '@lib/profile';
import { useIsMobile } from '@hooks';
import { RESOLUTION_BREAKPOINT } from '@constants';
const LimitlessLevelOutlet = () => {
    const navigate = useNavigate();
    const isSmallResolution = useIsMobile(RESOLUTION_BREAKPOINT.small);
    const { profile, investorBalance } = useProfile();
    const { pathname, state } = useLocation();
    useEffect(() => {
        if (state?.from?.pathname) {
            navigate(state?.from.pathname);
        }
        if (pathname !== '/') {
            return;
        }
        if (profile?.pendingCorrectionRequests.hasW8ContractRequest()) {
            navigate('/perfil/w8-contract');
        }
        else if (!profile?.hasTransactionalProfile()) {
            navigate('/update-transactional-profile');
        }
        else if (investorBalance?.hasInvested()) {
            if (isSmallResolution) {
                navigate('/home');
            }
            else {
                navigate('/marketplace');
            }
        }
        else {
            navigate('/onboarding');
        }
    }, [pathname]);
    return (_jsx(Outlet, {}));
};
export default LimitlessLevelOutlet;
